<template>
  <div>
    <v-app id="inspire" light>
      <app-sidenav></app-sidenav>
      <app-toolbar scroll-toolbar-off-screen></app-toolbar>

    <v-content id="divContent" v-scroll="onScroll" v-if="!isAppLoading">
         <router-view>
          <app-testcomp id="scroll-target"></app-testcomp>
        </router-view>

        <v-fab-transition>
          <v-btn
            v-show="!btnScrollHidden"
            color="black"
            fab
            dark
            bottom
            right
            fixed
            floating
            small
            @click="$vuetify.goTo('#divContent', {duration: 1000 , easing: 'easeInOutCubic' , offset: 0})"
          >
            <v-icon>keyboard_arrow_up</v-icon>
          </v-btn>
        </v-fab-transition>

        <cookie-banner></cookie-banner>
        <app-footer></app-footer>
    </v-content>
  </v-app>
  </div>
</template>

<script>
import TestComp from "./components/TestComponent.vue";
import TopHeader from "./components/pages/shared/TopHeader.vue";
import SideNav from "./components/pages/shared/SideNav.vue";
import Footer from "./components/pages/shared/Footer.vue";
import CookieBanner from "./components/pages/shared/CookiesBanner.vue";

export default {
  name: "app",
  data() {
    return {
      btnScrollHidden: true,
      offsetTop: 0,
      isAppLoading: true
    };
  },
  components: {
    "app-testcomp": TestComp,
    "app-toolbar": TopHeader,
    "app-sidenav": SideNav,
    "app-footer": Footer,
    "cookie-banner": CookieBanner
  },
  methods: {
    onScroll: function(e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
      if(this.offsetTop > 300) {
        this.btnScrollHidden = false;
      } else {
        this.btnScrollHidden = true;
      }
    }
  },
  beforeMount() {
    this.isAppLoading = true;
  },
  mounted() {
    this.isAppLoading = false;
  },
};
</script>

<style lang="scss">
@import "./scss/__base.scss";
@import "./scss/main.scss";
@font-face {
    font-family: "Old Stamper";
    src: url("/static/assets/font/old_stamper.ttf") format("truetype");
}

.app__loading-template {
  position: relative;
  display: block;
  width: 100vw;
  height: 100vh;
  padding-top: 4rem;
  background-image: linear-gradient(to bottom right, rgba(#03256c, 0.9), rgba(#2541b2, 0.9));

}

.app__loading-icon {
  position: absolute;
  font-size: 30rem;
  bottom: 0%;
  right: 0%;
  color: rgba(white, 0.05);
}
.app__loading-img-wrapper {
  position: relative;
  display: block;
  $app-img-loader-size: 30rem;
  width: 100%;
  height: $app-img-loader-size;
  // background-color: #333;
  // background-image: linear-gradient(to bottom right, #999, #999);
  background-repeat: repeat;


  .app__loading-img {
    position: absolute;
    display: inline-block;
    width: 80%;
    height: 100%;
    object-fit: contain;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    filter: drop-shadow(2px 2px 5px rgba(#333, 1));
    opacity: 0.5;
  }
}

.app__loading-text {
  font-size: 1.8rem;
  color: #eee;
  text-shadow: 2px 2px 5px rgba(#333, 1);
  opacity: 0.5;
}

.v-progress-circular {
  margin: 5rem;
  opacity: 0.5;
}


// --------------------------------------------------
// --------------------------------------------------
.minibasket__link-area {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  text-align: center;

   .minibasket__link-box {
     position: relative;
     display: inline-block;
     margin: 2rem 1rem;
     padding: 3rem 2rem;

     background-color: #53a2be;

      .link-box__icon {

        color: white;
        padding-right: 5px;
        padding-left: 5px;

      }

      .link-box__link {
        color: white;
      }
   }
}

.babybasket__copyright,
.minibasket__copyright {
  font-size: 1.4rem;
  font-style: italic;
}

.babybasket__subtitle,
.minibasket__section-title,
.legal-page__content h2,
.wp-area h2
 {
  // text-align: justify;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  color: #004f80;
}

.babybasket__section,
.minibasket__section,
.obe__section {
  p {
    // white-space: pre-line;
  }

ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
    color: #004f80; /* Change the color */
    font-weight: bold; /* If you want it to be bold */
    font-size: 1.8rem;
    display: inline-block; /* Needed to add space between the bullet and the text */
    width: 1em; /* Also needed for space (tweak if needed) */
    // margin-left: -1em; /* Also needed for space (tweak if needed) */
  }
}

.obe__encart-link {
  ul, li {
    list-style-type: none;
    list-style: none;
  }
}

.generic-title__title,
.legal-page__content h1,
.wp-area h1 {
  position: relative;
  display: inline-block;
  color: #333;
  font-size: 3rem;
  letter-spacing: 3.5px;
  font-weight: 500;
  text-transform: uppercase;
  width: "auto";
  height: "auto";
  margin-bottom: 4rem;
  margin-top: 5rem;

  &:before {
    content: " ";
    display: block;
    position: absolute;
    height: 3px;
    width: 30%;
    background-color: #003759;
    background-image: url();
    bottom: -15px;
    left: 15%;
    transform: translate(-50%);
  }
}

// ------------ news agenda ---------------------
.news-agenda {
  position:relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // padding: 1rem;
  // background-color:  #F2F2F2;

  width: 100%;
  height: auto;

  // --------- TOP ----------
  // --------- Side Left -------
  $news-agenda-height: 12.5rem;
  &__item {
    position: relative;
    display: flex;
    flex-direction: row;

    width: 100%;
    height: auto;
    padding: 1rem;
    box-sizing: border-box;
    border: 2px solid transparent;

    @media screen and (max-width: 960px) {
      // overflow-y: hidden;
      // overflow-x: auto;

      // height: 15rem; CDE
    }

    @media screen and (max-width: 590px) {
       flex-wrap: wrap;
       justify-content: center;
    }

    // @media screen and (max-width: 775px) {
    //   // overflow-y: hidden;
    //   // overflow-x: auto;
    //   height: 20rem;
    // }

    // @media screen and (max-width: 600px) {
    //   // overflow-y: hidden;
    //   // overflow-x: auto;
    //   height: 15rem;
    // }




    // overflow: hidden;

    &:hover {
      background-color: #f0f0f0;
      // border: 2px solid #003759;
    }
  }

  &__header-box {
    position: relative;
    // display: inline-block;
    display: flex;
    height: $news-agenda-height;
    width: calc($news-agenda-height * 2 + 5px);
    background-color: #F0F0F0; // #E9E9E9;
    // vertical-align: top;
    // margin-top: 1rem;
  }

  &__img-wrapper {
    position: relative;
    display: inline-block;
    width: $news-agenda-height;
    height: 100%;
    overflow: hidden;
    // background-color: lightgreen;
  }

  &__img {
    position: relative;
    display: block;
    width: $news-agenda-height;
    height: 100%;
    object-fit: contain;
  }

  @media screen and (max-width: 960px)
  {
    &__header-box {
      min-width: $news-agenda-height;
      max-width: $news-agenda-height * 2;
    }

    &__img-wrapper {
      // display: none;
    }

    &__img {
      position: relative;
      display: block;
      width: $news-agenda-height;
      height: 100%;
      // object-fit: cover;
    }
  }

  &__head-wrapper {
    // position: absolute;
    position: relative;
    display: inline-block;
    height: 100%;
    width: $news-agenda-height;
    background-color: lighten(lightblue, 15%);
    // overflow-wrap: break-word;
    font-family: "Oswald", "Open Sans", "Lato", Arial, Helvetica, sans-serif;
    top: 0;
    right: 0;

    color: #06bee1;

    text-align: center;
  }

  $head-date-content-height: 75%;

  &__head-date-content {
    position: relative;
    display: block;
    width: 100%;
    height: $head-date-content-height;
    padding-top: 4px;
  }
  &__head-date-month {
    position: relative;
    display: block;
    font-size: 1.8rem;
    font-weight: 400;
    // line-height: 12px;
    width: 100%;
    text-transform: uppercase;
  }

  &__head-date-divider {
    position: relative;
    display: block;
    margin: 0.5rem auto;
    height: 1px;
    width: 25%;
    background-color: #06bee1;
  }
  &__head-date-day {
    font-size: 3rem;
    font-weight: 600;
  }
  &__head-taxo-content {
    position: absolute;
    display: block;
    width: 100%;
    height: 100% - $head-date-content-height;
    left: 0;
    bottom: 3px;
  }

  &__taxo {
    position: relative;
    display: block;
    width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // overflow-wrap: break-word;
    color: white;
    height: 100%;
    padding-top: 2px;
  }

  // ---------- Desc ------
  &__content-box {
    // position: absolute;
    position: relative;
    display: block;
    // word-wrap: break-word;
    // background-color:purple;
    // top:0;
    // left: $news-agenda-height - 2rem;
    // left:  $news-agenda-height * 2 + 1rem;
    width: auto;//calc(100%-1.5rem);// calc(100% - $news-agenda-height * 2 - 1rem);
    height: auto;
    padding-bottom: 2px;
    margin-bottom: 2px;

    // background-color: orangered;
  }

  &__title-wrapper {
    position: relative;
    display: inline-block;
    // background-color: yellow;
    height: 20%;
    width: auto;
  }

  &__title {
    position: relative;
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
    font-family: "Oswald", "Open Sans", "Lato", Arial, Helvetica, sans-serif;
    font-size: 1.8rem;
    color: #004f80;
    cursor: pointer;
  }

  &__news-agenda__desc-container {
    position: relative;
    display: block;
    width: 100%;
  }

  &__info-wrapper {
    position: relative;
    display: block;
    width: auto;

    & > * {
      margin-left: 10px;
    }
  }
  &__info-category,
  &__info-addr-title {
    position:relative;
    display: inline-block;
    font-family: "Oswald", "Open Sans", "Lato", Arial, Helvetica, sans-serif;
    color: #004f80;
    width: auto;
  }
  &__info-date,
  &__info-addr {
    position: relative;
    display: block;
    font-size: 1.4rem;
    color: #777;
    width: auto;

    @media screen and (max-width: 550px) {
      // display: none;
    }
  }

  // ------ BOTTOM ------
  &__bottom-wrapper {

  }
}


// ------------------- responsive video ---------------------------
.embedresize {
  max-width: 560px;
  margin: auto;

  div {
    position: relative;
    height: 0;
    padding-bottom: 56.25%;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

}

.intro #intro .embedresize iframe,
.exit .quizz .embedresize iframe,
.alreadyplayed #intro .embedresize iframe,
.identityset #intro .embedresize iframe,
#notabene .embedresize iframe,
#message_intro .embedresize iframe,
.fancybox_body .embedresize iframe,
#comments .embedresize iframe,
#description .embedresize iframe,
.alreadyplayed .embedresize iframe,
#adserver .embedresize iframe {
  max-width: none !important;
}

@media print {
 /* All your print styles go here */
  footer,
  .nav-drawer,
  .shared-buttons,
  #main-menu-toolbar
  { display: none !important; }
}
</style>



// WEBPACK FOOTER //
// src/App.vue